function menuItemsOnSide (items, side) {

  const wantRight = side === 'right'

  return (items || []).filter(item => !!item.alignRight === wantRight)
}

module.exports = menuItemsOnSide
